/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_PasswordInputs */

const en_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot your password?`)
};

const es_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Olvidaste tu contraseña?`)
};

/**
* | output |
* | --- |
* | "Forgot your password?" |
*
* @param {Auth_Forgot_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_password = /** @type {((inputs?: Auth_Forgot_PasswordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_PasswordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_forgot_password(inputs)
	return en_auth_forgot_password(inputs)
});